import React from 'react';
import { Helmet } from 'react-helmet-async';

const Seo = ({ title, description, path }) => {
    const baseUrl = 'https://savematic.pro';
    const fullUrl = `${baseUrl}${path}`;
    
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={fullUrl} />
            
            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={`${baseUrl}/og-image.jpg`} />
            
            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={fullUrl} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={`${baseUrl}/og-image.jpg`} />
            
            {/* Additional meta tags */}
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="index, follow" />
            <meta name="language" content="English" />
            <meta name="author" content="Savematic" />
        </Helmet>
    );
};

export default Seo; 